import React from 'react';

function Navigation() {
  return (
       <nav id="navigateur">
            <a href="/"><img id="logo" src="/img/logo.png" alt='logo de foot pro manager' /></a>
            <a href="/">Accueil</a>
            <a href="/equipe">Equipes</a>
            <a href="/contact">Contact</a>
            <a href="/connexion">Connexion</a>
            <a href="/inscription">Inscription</a>
        </nav>
  );
}

export default Navigation;
